export enum ErrorMessageEnum {
  requiredField = "Campo de preenchimento obrigatório",
  invalidEmail = "Email inserido não é válido",
  invalidPhone = "O número deve ter 9 dígitos.",
  invalidPin = "O PIN deve ter 5 dígitos.",
  passwordMismatch = "As palavras-chave inseridas devem ser iguais.",
  imageInvalidType = "O tipo da imagem selecionada não é válido",
  imageInvalidSize = "O tamanho da imagem selecionada excede o limite permitido"
}
